import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './plugins/router'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import 'highlight.js/styles/stackoverflow-light.css'
import 'highlight.js/lib/common'
import './styles/preferences.scss'
import hljsVuePlugin from '@highlightjs/vue-plugin'
// @ts-ignore
import timeago from 'vue-timeago3'
// @ts-ignore
import Vue3Signature from 'vue3-signature'
import App from './App.vue'

const app = createApp(App)
const pinia = createPinia()

// Initialize Pinia FIRST before importing sde-client components
// (sde-client components import stores at module level)
app.use(pinia)

// Now import and register sde-client components
import('sde-client/components').then((sdeComponents) => {
  Object.entries(sdeComponents).forEach(([name, component]) => {
    app.component(name, component as any)
  })

  app
    .use(vuetify)
    .use(router)
    .use(i18n)
    .use(timeago)
    .use(hljsVuePlugin)
    .use(Vue3Signature)
    .mount('#app')
})
